module.exports = __webpack_public_path__ + "Roboto-Light.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Light.eot
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Light.eot
// module chunks = 3